// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconStyledForChips-module_icon__pOQj5adE-nOO6vTZ-CJ82","avatar":"IconStyledForChips-module_avatar__369oyff3GlbfuYbQOoydLB"};